// Mock data for LSTOIT clone
export const navLinks = [
  { label: 'DACHY PŁASKIE', href: '#dachy' },
  { label: 'SYSTEM EPDM / RESITRIX / HERTALAN', href: '#epdm' },
  { label: 'SYSTEM TPO/FPO/PVC BAUDER', href: '#tpo' },
  { label: 'REALIZACJE', href: '#realizacje' },
  { label: 'O FIRMIE', href: '#o-firmie' },
  { label: 'KONTAKT', href: '#kontakt' },
];

export const promisePillars = [
  {
    icon: 'Layers',
    title: 'SYSTEM',
    text: 'Pracujemy na sprawdzonych technologiach: EPDM Carlisle HERTALAN oraz RESITRIX SKW od Bauder, TPO/FPO oraz PVC od Bauder.'
  },
  {
    icon: 'Crosshair',
    title: 'DETAL',
    text: 'Najwięcej uwagi poświęcamy miejscom, które najczęściej zawodzą.'
  },
  {
    icon: 'ShieldCheck',
    title: 'ODPOWIEDZIALNOŚĆ',
    text: 'Odpowiedzialność nie kończy się na odbiorze. Jesteśmy ludźmi, a nie teorią. Jeśli coś wymaga korekty – reagujemy. Nie zostawiamy klienta z problemem.'
  },
];

export const services = [
  'Dachy płaskie na domach jednorodzinnych',
  'Tarasy nad pomieszczeniami',
  'Attyki, wpusty, przelewy awaryjne',
  'Obróbki blacharskie',
  'Hydroizolacje EPDM / RESITRIX',
  'Naprawy i przebudowy dachów płaskich',
  'Dachy dla budynków premium i inwestycji indywidualnych',
];

export const realizations = [
  {
    title: 'ŚLIWOWA 34, WROCŁAW',
    subtitle: 'Etap I oraz Etap II',
    system: 'SIKAPLAN 15G',
    area: '1 400 m²',
    detail: 'Inwestycja wykonana w oparciu o membranę SIKAPLAN 15G',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/0es67kwt_20200531_174627%20%281%29.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/pplk2x6b_20200531_174635.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/lxymn961_20210413_105654.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/zqudwbhw_20210413_105655.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/lsz4wgqi_20210427_170526.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/1nboxv63_20210430_154216.jpg',
    ],
  },
  {
    title: 'LAKE HILL RESORT & SPA',
    subtitle: 'Sosnówka — Etap III',
    system: 'RESITRIX SKW + HERTALAN',
    area: '450 m²',
    detail: 'Inwestycja wykonana w oparciu o membrany RESITRIX SKW oraz HERTALAN',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/dzynewr1_20230210_171135.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/x1p6diel_20230211_092539.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/havu6mci_20230215_160940.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/8hdqlacg_20230217_092524.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/varrhu33_20230217_092529.jpg',
    ],
  },
  {
    title: 'OSIEDLE WILLA RÓŻA',
    subtitle: 'Siechnice — wykonaliśmy 7 z 13 budynków',
    system: 'SIKAPLAN 15G + RESITRIX SKW',
    area: '980 m²',
    detail: 'Inwestycja wykonana w oparciu o membranę SIKAPLAN 15G oraz RESITRIX SKW',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/t4fbvgpj_20220318_151028.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/tiz84es4_20220319_134821.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/k7br1s29_20220330_133928.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/1fqfwozg_20220330_155421.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/d7we06ub_20220330_155423.jpg',
    ],
  },
  {
    title: 'RADISSON SZKLARSKA PORĘBA',
    subtitle: 'Hotel górski',
    system: 'RESITRIX SKW',
    area: '1 300 m²',
    detail: 'Inwestycja wykonana w oparciu o membranę RESITRIX SKW',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/qokqwx25_20190630_081720.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/5ump75eg_20190630_081607.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/enwsk2ys_20190630_081620.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/t8ccwm3c_20190630_081601.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/qzpc7ui4_20190630_081657.jpg',
    ],
  },
  {
    title: 'PRZEDSZKOLE LIPI, WROCŁAW',
    subtitle: 'Remont dachu',
    system: 'RESITRIX SKW',
    area: '1 200 m²',
    detail: 'Inwestycja wykonana w oparciu o membranę RESITRIX SKW',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/1qa3i52l_20201101_110833.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/8f8jfxp0_20201020_072321.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/yiw941vt_20201020_175935.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/qpsnp9td_20201021_152135.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/mbcnq9v5_20201023_072728.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/h4zgb5ta_20201107_131257.jpg',
    ],
  },
  {
    title: 'CLARENA',
    subtitle: 'Remont pokrycia',
    system: 'RESITRIX + HERTALAN (system klejony)',
    area: '780 m²',
    detail: 'Inwestycja wykonana w systemie klejonym — łącznie 780 m² membran RESITRIX i HERTALAN',
    images: [
      '/clarena/clarena-1.jpg',
      '/clarena/clarena-2.jpg',
      '/clarena/clarena-3.jpg',
      '/clarena/clarena-4.jpg',
      '/clarena/clarena-5.jpg',
    ],
  },
  {
    title: 'PROJEKT RADOMIERZYCE',
    subtitle: 'Realizacja indywidualna',
    system: 'FATRA',
    area: '1 100 m²',
    detail: 'Inwestycja wykonana w oparciu o membranę FATRA',
    images: [
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/7fnao7lx_20191025_171053.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/96gjy9vk_20191210_142948.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/8atrgkw0_20191210_142951.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/gtykwayj_20191210_142953.jpg',
      'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/0szsajzg_20191210_143008.jpg',
    ],
  },
];

export const whyUs = [
  'Pracujemy na systemowych materiałach',
  'Nie mieszamy przypadkowych technologii',
  'Wykonujemy obróbki blacharskie',
  'Pilnujemy odwodnienia i przelewów awaryjnych',
  'Pokazujemy klientowi newralgiczne miejsca',
  'Bierzemy odpowiedzialność za efekt końcowy',
];

export const processSteps = [
  { num: 1, icon: 'Binoculars', title: 'Oględziny', text: 'Sprawdzamy podłoże, spadki, detale i odwodnienia.' },
  { num: 2, icon: 'FileText', title: 'Dobór systemu', text: 'Dobieramy rozwiązanie do budynku, nie odwrotnie.' },
  { num: 3, icon: 'Calculator', title: 'Wycena', text: 'Otrzymujesz konkretny zakres prac i materiałów.' },
  { num: 4, icon: 'Wrench', title: 'Realizacja', text: 'Pracujemy etapami, z naciskiem na szczelność detali.' },
  { num: 5, icon: 'ShieldCheck', title: 'Odbiór', text: 'Pokazujemy wykonane miejsca krytyczne.' },
];

export const reviews = [
  {
    text: 'Profesjonalne podejście od początku do końca. Detale dopracowane perfekcyjnie. Dach szczelny, zero problemów.',
    author: 'Michał, Wrocław',
  },
  {
    text: 'Rzadko spotyka się taką dokładność. Widać doświadczenie i znajomość systemów. Polecam każdemu, kto szuka jakości.',
    author: 'Karolina, Wrocław',
  },
  {
    text: 'Taras wykonany w systemie RESITRIX. Wszystko zgodnie z ustaleniami, świetny kontakt i terminowość.',
    author: 'Tomasz, Wrocław',
  },
  {
    text: 'Firma godna zaufania. Pokazali wszystkie newralgiczne miejsca, doradzili najlepsze rozwiązanie. Polecam.',
    author: 'Daniel, Wrocław',
  },
];

export const heroImage = 'https://customer-assets.emergentagent.com/job_admiring-kepler-5/artifacts/r3zjxz5y_20210819_132023.jpg';
export const forWhoImage = 'https://images.pexels.com/photos/13620065/pexels-photo-13620065.jpeg?w=1200&q=80';
export const whyUsImage = 'https://images.unsplash.com/photo-1746068012622-bda3402e6e73?w=900&q=80';
export const ctaBgImage = 'https://images.unsplash.com/photo-1746068012622-bda3402e6e73?w=1920&q=80';
